var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetStampPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.537 65.0838L82.4851 59.3926L76.7921 124.464L141.844 130.155L147.537 65.0838Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.577422,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 31.3C2.5 28.2766 3.70107 25.3769 5.83898 23.239C7.9769 21.1011 10.8765 19.9 13.9 19.9C15.8215 19.8999 17.7124 20.3812 19.4 21.3V91.5C17.7124 90.5812 15.8215 90.0999 13.9 90.1C10.8765 90.1 7.9769 91.3011 5.83898 93.439C3.70107 95.5769 2.5 98.4766 2.5 101.5V31.3Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2 77.9001C52.3 78.8001 53.2 79.4001 54.4 79.4001C55.6 79.4001 56.4 78.8001 56.4 78.0001C56.4 77.2001 55.8999 76.8001 54.7999 76.5001L53.7 76.2001C52.1 75.8001 51.4 75.2001 51.4 74.0001C51.4 72.8001 52.7 71.6001 54.4 71.6001C54.7549 71.5584 55.1146 71.5876 55.4581 71.686C55.8017 71.7844 56.1223 71.9501 56.4014 72.1733C56.6804 72.3966 56.9124 72.673 57.0838 72.9866C57.2552 73.3002 57.3627 73.6446 57.4 74.0001H56.2999C56.2752 73.7762 56.2062 73.5595 56.0969 73.3625C55.9877 73.1656 55.8404 72.9923 55.6637 72.8527C55.4869 72.7131 55.2841 72.6101 55.0672 72.5496C54.8503 72.489 54.6234 72.4722 54.4 72.5001C53.3 72.5001 52.5 73.1001 52.5 74.0001C52.5 74.9001 52.9999 75.0001 54.0999 75.3001L55 75.5001C56.8 76.0001 57.5 76.6001 57.5 77.9001C57.5 79.2001 56.2999 80.4001 54.2999 80.4001C52.2999 80.4001 51.3 79.4001 51.2 77.9001H52.2Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.166665,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7 85.9001C60.2781 85.9001 64.8 81.3782 64.8 75.8001C64.8 70.222 60.2781 65.7001 54.7 65.7001C49.1219 65.7001 44.6 70.222 44.6 75.8001C44.6 81.3782 49.1219 85.9001 54.7 85.9001Z",
    stroke: "#DB6C2F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.9 96.2H34.1V47.5H48.5",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1 47.5H99.6V55.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3 53.6L80.6 46.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2 69.6H75.9",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5 110.9H14.1C11.3233 110.874 8.66768 109.759 6.70418 107.796C4.74067 105.832 3.62605 103.177 3.59998 100.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 32.7001H114.3V56.9001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.711 70.8108L88.4113 66.2351L83.8356 118.535L136.136 123.111L140.711 70.8108Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M139.5 96.2L112.9 93.9C111.3 93.8 110.8 94.6 110.7 96.1L108.4 121.8",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3 120.3L94.6 93.4C95.0321 88.8257 97.2459 84.6048 100.763 81.6487C104.281 78.6925 108.82 77.2383 113.4 77.6L141 80.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.8 94.2L126.6 88.2L124.1 85.3L128.9 81.3",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M122.4 81.7001L124 85.2001",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetStampPhoto);
export default __webpack_public_path__ + "static/media/sheet_stamp_photo.4924f41761e0d33096b710ece2bb9ef2.svg";
export { ForwardRef as ReactComponent };